import { useRef, useEffect } from 'react';
export function useDebounceHandler(handler, watchedValue, delay) {
    var firstRender = useRef(true);
    useEffect(function () {
        if (firstRender.current) {
            firstRender.current = false;
            return function () { };
        }
        var timeoutId = setTimeout(function () { return handler(); }, delay);
        return function () {
            clearTimeout(timeoutId);
        };
    }, [watchedValue, delay]);
}
